import React from 'react';
import GalleryIndustrial from '../industrial/GalleryIndustrial';
import PageHeader from '../industrial/PageHeader';
import SEO from '../SEO';
import { breadcrumbSchema } from '../../utils/structuredData';

const GalleryPage: React.FC = () => {
  const breadcrumbs = breadcrumbSchema([
    { name: 'Inicio', url: 'https://junisama.com.co' },
    { name: 'Galería', url: 'https://junisama.com.co/galeria' }
  ]);

  return (
    <>
      <SEO
        title="Galería de Eventos | Junisama - Festivales, Conciertos y Eventos Corporativos"
        description="Conoce nuestros proyectos más destacados: Rock al Parque, Estéreo Picnic, Festival de las Flores, eventos corporativos y más. Más de 500 eventos exitosos en Colombia. Clientes satisfechos en Bogotá, Medellín y todo el país."
        keywords="galería eventos junisama, proyectos baños portátiles, festivales Colombia, Rock al Parque, Estéreo Picnic, eventos corporativos, clientes junisama, casos éxito"
        url="/galeria"
        structuredData={breadcrumbs}
      />
      <PageHeader
        title="NUESTRA"
        titleHighlight="GALERÍA"
        subtitle="Descubre nuestros proyectos más destacados y la confianza que las principales empresas del país depositan en nuestros servicios de infraestructura sanitaria portátil."
      />
      <GalleryIndustrial />
    </>
  );
};

export default GalleryPage;
